import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/multiLocationOverviewSaga";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const FilterLevelFourthSelect = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.multiLocationOverview.availableFilters.level_4);
  const selectedOptions = useSelector((state) => state.multiLocationOverview.selectedLevelFourth);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOptions}
      placeholder="Please Select"
      enableOnly
      numberDisplayed={0}
      includeSelectAll
      onSelectChange={(data) => dispatch(actionCreators.updateSelectedFourthLevelFilters(data))}
    />
  );
};

export default FilterLevelFourthSelect;
